import { z } from "zod";
import { EventAttendeeStatus } from "../enum.js";

export const respondEventSchema = z
	.object({
		action: z.enum(EventAttendeeStatus),
		reason: z.string().max(500).optional(),
	})
	.strict();

export type RespondEventPayload = z.infer<typeof respondEventSchema>;
